import React, { useEffect , useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Button, Col, Row, Spinner, Input, InputGroup, InputGroupText } from 'reactstrap';
import { Chart as ChartJS, registerables } from 'chart.js';
import Title from '../../../sharedComponents/Title/Title';
import useDataSuite from '../useDataSuite';
import { FaExpand, FaTrash } from 'react-icons/fa';
import { BsPencilSquare, BsSearch } from 'react-icons/bs';
import { IoMdInformationCircle } from "react-icons/io";
import { Tooltip } from "@mui/material";
import useDataSuiteWidgets from './useDataSuiteWidgets';
import { isEqual } from "lodash";
import EmptyDataMessage from '../../../sharedComponents/ErrorMessages/EmptyDataMessage';
import { Theme } from '../../../config/constants';

ChartJS.register(...registerables);

const TargetsByCategoryWidget = (props) => {
    const { w, i } = props;
    const {  onClickWidgetDrawerOpen, onClickDeleteWidget, onClickWidgetDetailsDrawerOpen } = useDataSuite.useWidgetControls();
    const { widgetDetailsContent, widgetTitle, targetsByCategoryMap, targetsByCategoryTableData, targetsByCategoryDetailsTableData } = useDataSuiteWidgets.useTargetsByCategoryWidget();
    const detailsDrawerTitle = useSelector(({datasuite})=> datasuite.widgetDetailsDrawer.title);
    const detailsDrawerOpen = useSelector(({ui}) => ui.datasuiteWidgetDetailsSlideDrawer);
    const widgetOptionsOpen = useSelector(({ui}) => ui.slideDrawer);
    const selectedFilters = useSelector(({datasuite}) => datasuite.selectedFilters);
    const selectedDetailsFilters = useSelector(({datasuite}) => datasuite.selectedDetailsFilters);
    const dateString = useSelector(({dates}) => dates.datasuiteDateString);
    const detailsDateString = useSelector(({dates}) => dates.datasuiteDetailsDateString);
    const isLoading = useSelector(({datasuite}) => datasuite.isLoading.targetsByCategoryLoading);
    const { getTargetsByCategory, filterTargetsByCategoryTable } = useDataSuite.useDataSuite();
    const [isWidgetHovered, setIsWidgetHovered] = useState(false);

    const prevFilters = useRef(null);
    const prevDate = useRef(null);

    const handleMouseEnter = () => {
        setIsWidgetHovered(true);
    };
    const handleMouseLeave = () => {
        setIsWidgetHovered(false);
    };

    useEffect(() => {
        if (isEqual(selectedFilters, prevFilters.current) && isEqual(dateString, prevDate.current)) {
            getTargetsByCategory(true);
        } else {
            getTargetsByCategory(false);   
        }
        prevFilters.current = selectedFilters;
        prevDate.current = dateString;

    // eslint-disable-next-line
    }, [selectedFilters, selectedDetailsFilters, dateString, detailsDateString]);

    // eslint-disable-next-line
    useEffect(() => {if(detailsDrawerOpen && (detailsDrawerTitle === widgetTitle)) {onClickWidgetDetailsDrawerOpen(widgetTitle, widgetDetailsContent);}}, [targetsByCategoryDetailsTableData]);

    if(isLoading || targetsByCategoryTableData.length <= 0) {
        return (
            <Col className='w-100 h-100' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{position:'relative', minHeight: '300px'}}>
                <Row className='d-flex align-items-center'>
                    <Col className='w-fc pr-0'>
                        <div className='d-flex align-items-center px-0'>
                        <Title title={widgetTitle}/>
                        <Tooltip title='Displays operator purchases by your relevant categories compared to purchases in those same categories to competitive MFRs. Helpful for identifying category areas of growth to focus on.' arrow>
                            <div className='pt-3 pb-2'>
                            <IoMdInformationCircle className="text-size-18 " style={{color: Theme().colors.accent}}/>
                            </div>
                        </Tooltip>
                        </div>
                    </Col>
                    {(widgetOptionsOpen || isWidgetHovered)  && ( <>
                        <Col className='w-fc px-1 pt-3 pb-2'>
                            <Button 
                                block 
                                className='py-1 button-label replaceWidgtButton' 
                                size='sm' 
                                color='blueFilter'
                                onClick={() => onClickWidgetDrawerOpen("Replace Widget", true, i)}>
                                <BsPencilSquare color='white' /> 
                            </Button>
                        </Col>
                        <Col className='w-fc px-1 pt-3 pb-2'>
                            <Button
                                block 
                                className='py-1 button-label deleteWidgetButton' 
                                size='sm' 
                                color='redLight'
                                onClick={() => onClickDeleteWidget(w)}>
                                <FaTrash color='white' />
                            </Button>
                        </Col>
                    </>
                    )}
                    <Col className={`w-fc me-3 ms-auto px-1 pt-3 pb-2`}>
                        <Button
                            block 
                            className='py-1 button-label expandWidgetButton' 
                            size='sm' 
                            outline={true}
                            color={Theme().colors.accentName}
                            onClick={() => onClickWidgetDetailsDrawerOpen(widgetTitle, widgetDetailsContent)}>
                            <FaExpand color={Theme().colors.accentName} /> Expand
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <InputGroup size='sm'>
                        <InputGroupText>
                            <BsSearch/>
                        </InputGroupText>
                        <Input className='text-input' id="targetsByCategorySearchInput" placeholder='Search...'/> 
                    </InputGroup>
                </Row>
                <Row className="mx-auto"style={{minHeight: '70%'}}>
                    <Col className="mx-auto my-auto" style={{height:"2.5%", width:"2.5%"}}>
                        {isLoading &&
                        <Spinner style={{marginLeft:'50%'}} color='beplBlue' animation="border" />
                        }
                        {!isLoading && (targetsByCategoryTableData.length <= 0) &&
                        <EmptyDataMessage />
                        }
                    </Col>
                </Row>
            </Col>
        );
    }
    else return (
        <Col onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ position: 'relative'}} >
            <Row className='d-flex align-items-center'>
                <Col className='w-fc pr-0'>
                    <div className='d-flex align-items-center px-0'>
                    <Title title={widgetTitle}/>
                    <Tooltip title='Displays operator purchases by your relevant categories compared to purchases in those same categories to competitive MFRs. Helpful for identifying category areas of growth to focus on.' arrow>
                        <div className='pt-3 pb-2'>
                        <IoMdInformationCircle className="text-size-18 " style={{color: Theme().colors.accent}}/>
                        </div>
                    </Tooltip>
                    </div>
                </Col>
                {(widgetOptionsOpen || isWidgetHovered)  && ( <>
                    <Col className='w-fc px-1 pt-3 pb-2'>
                        <Button 
                            block 
                            className='py-1 button-label replaceWidgetButton' 
                            size='sm' 
                            color='blueFilter'
                            onClick={() => onClickWidgetDrawerOpen("Replace Widget", true, i)}>
                            <BsPencilSquare color='white' /> 
                        </Button>
                    </Col>
                    <Col className='w-fc px-1 pt-3 pb-2'>
                        <Button
                            block 
                            className='py-1 button-label deleteWidgetButton' 
                            size='sm' 
                            color='redLight'
                            onClick={() => onClickDeleteWidget(w)}>
                            <FaTrash color='white' />
                        </Button>
                    </Col>
                </>
                )}
                <Col className={`w-fc me-3 ms-auto px-1 pt-3 pb-2`}>
                    <Button
                        block
                        className={`py-1 button-label expandWidgetButton`}
                        size='sm'
                        outline={true}
                        color={Theme().colors.accentName}
                        onClick={() => onClickWidgetDetailsDrawerOpen(widgetTitle, widgetDetailsContent)}>
                        <FaExpand color={Theme().colors.accentName} /> Expand
                    </Button>
                </Col>
            </Row>
            <Row className='mb-2'>
                <InputGroup size='sm'>
                    <InputGroupText>
                        <BsSearch/>
                    </InputGroupText>
                    <Input className='text-input' id="targetsByCategorySearchInput" placeholder='Search...' onChange={() => filterTargetsByCategoryTable()}/> 
                </InputGroup>
            </Row>
            <Row className="w-100 mb-3 mx-0" style={{height: '350px'}}>
                <Col className="col-12 text-size-14 p-0 h-100">
                    <Row className='me-1' style={{overflowY: 'auto', height: '100%'}}>
                        <div>
                            <table className="table targetsByCategoryTable border-grayLight" id="targetsByCategoryTable">
                                <thead>
                                <tr>
                                    <th scope="col" >CATEGORY</th>
                                    <th scope="col" >TOTAL CASES</th>
                                    <th scope="col" >TARGET CASES</th>
                                </tr>
                                </thead>
                                {(targetsByCategoryTableData.length > 0) &&
                                <tbody>
                                    {targetsByCategoryMap}
                                </tbody>
                                }
                            </table>
                            {(targetsByCategoryTableData.length <= 0) && 
                            <div className='text-size-20' style={{textAlign: 'center'}}>No Data To Display.</div>
                            }
                        </div> 
                    </Row>
                </Col>
            </Row>
        </Col>
    );
    
}

export default TargetsByCategoryWidget;